import React from 'react';
import { Fade } from '@material-ui/core';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import FsGridContainer from 'ui-elements/grid/FsGridContainer/FsGridContainer';
import FsGridItem from 'ui-elements/grid/FsGridItem/FsGridItem';
import FsInviteNewCustomerForm from 'ui-elements/forms/FsInviteNewCustomerForm';
import FsMagicLinkForm from 'ui-elements/forms/FsMagicLinkForm';
import defaultLocales from 'globals/locales/default';
import { BoxWithBorder, Title, WrapperBox } from './InviteForms.style-elements';

const url = 'https://friendlyscore.com/share/openbanking-demo';

const InviteForms: React.FC = () => {
  return (
    <WrapperBox>
      <Fade in timeout={1000}>
        <FsPaper withContentMargin={false}>
          <FsGridContainer withMargin={false}>
            <FsGridItem xs={12} lg={8}>
              <BoxWithBorder>
                <Title>{defaultLocales.inviteCustomer}</Title>
                <FsInviteNewCustomerForm />
              </BoxWithBorder>
            </FsGridItem>
            <FsGridItem xs={12} lg={4}>
              <Title>{defaultLocales.inviteCustomerWithMagicLink}</Title>
              <FsMagicLinkForm url={url} />
            </FsGridItem>
          </FsGridContainer>
        </FsPaper>
      </Fade>
    </WrapperBox>
  );
};

export default InviteForms;
